import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iso8601'
})

export class Iso8601Pipe extends DatePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: any, _args?: any): any {
    return super.transform(value, 'yyyy-MM-dd HH:mm');
  }
}
